<template>
  <div>
    <h2 class="grey--text text-left">Teknologier brukt</h2>
      <v-row>
          <v-col v-for="technology in used" v-bind:key="technology">
          <v-chip
      class="ma-2"
      color="primary"
    >
      {{technology}}
    </v-chip>
      </v-col>
      </v-row>
  </div>
</template>

<script>
export default {
    props: ['used']
}
</script>

<style>

</style>